<template>
  <div v-title :data-title="loginType==4?'家游客 | 微信绑定':'直客 | 微信绑定'">
    <div class="page">
      <div class="logo">
        <img src="../../assets/img/03.jpg">
      </div>
      <div class="weui-cells weui-cells_form">
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__bd">
            <input
              class="weui-input phone"
              type="text"
              placeholder="请输入用户名"
              v-model="user.UserName"
            >
          </div>
        </div>
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__bd">
            <input class="yzm" type="password" placeholder="请输入密码" v-model="user.Password">
          </div>
        </div>
      </div>
    </div>
    <div class="weui-btn-area">
      <a class="weui-btn weui-btn_primary btn-login" @click="loginAndBind()">绑&nbsp;&nbsp;&nbsp;定</a>
    </div>
  </div>
</template>
<script>
import { Toast } from "we-vue";
export default {
  name: "bindaccount",
  data() {
    return {
      user: { UserName: "", Password: "" },
      switchValue: false,
      code: "",//获取授权后回调code
      loginType: -1
    };
  },
  created: function() {
    var url = window.location.href;
    this.code = this.GetRequest(url)["code"];
    var type = this.$route.query.type;
    if (type == "dis") {
      this.loginType = 4;
    } else {
      this.loginType = 5;
    }
    if (this.code != undefined && this.code != null && this.code.length > 0) {
      this.checkBindWechat();
    }
  },
  methods: {
    setcache: function() {
      var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
      promise.then(function(d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          localStorage.setItem("cachedict", JSON.stringify(rep.Data));
          Toast.success("登录成功");
          window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
        } else {
          Toast.fail(rep.Message);
        }
      });
    },
    loginAndBind: function() {
      console.info(this.code);
      if (this.user.UserName == "") {
        Toast.fail("用户名不能为空");
        return;
      }
      if (this.user.Password == "") {
        Toast.fail("密码不能为空");
        return;
      }
      if (this.switchValue) {
        localStorage.setItem("user", JSON.stringify(this.user));
      } else {
        localStorage.setItem("user", "");
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/loginandbind", {
          params: {
            UserName: this.user.UserName,
            Password: this.user.Password,
            LoginType: this.loginType,
            code: this.code
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              localStorage.setItem("token", JSON.stringify(rep.Data));
              localStorage.setItem("loginType", this.loginType);
              this.setcache();
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    checkBindWechat: function() {
      console.info(this.code);
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/checkbindwechatbycode", {
          params: {
            code: this.code,
            loginType: this.loginType
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success && rep.Data != null && rep.Data.length > 0) {
              localStorage.setItem("token", JSON.stringify(rep.Data));
              //已经绑定，直接登录成功
              localStorage.setItem("loginType", this.loginType);
              this.setcache();
              
            } else if (!rep.Success) {
              if (this.loginType == 4) {
                window.location.href =
                  this.GLOBAL.WEB_URL + "/#/account/login?type=dis";
              } else {
                window.location.href = this.GLOBAL.WEB_URL + "/#/account/login";
              }
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/login/wechatbindaccount.vue